import { postBroadcastEvent } from "./post_messages";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Constants
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

const RESPONSE_COMPLETE_EVENT = "dewey:response-complete";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Methods
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

// Broadcasting / Posting

function broadcast(event, eventDetail, version = 0) {
  const detail = {
    ...eventDetail,
    apiVersion: `v${version}`
  }
  // Dispatch an event to the current document (for mobile contexts)
  document.dispatchEvent(new CustomEvent(event, { detail, bubbles: true, cancelable: true }));
  // Post a message to the parent document (for iFrame contexts)
  postBroadcastEvent(event, detail);
}

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// API Export
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

export const JavascriptAPI = {
  // v0 API Version
  v0: {
    broadcastResponseComplete:({
      responseType, // answer_routing, answer_direct, answer_keyword
      createdAt,     // created_at in UTC ISO8601
      interactionCount      // Number of turns in the conversation (including the one that was just completed)
    }) => {
      broadcast(RESPONSE_COMPLETE_EVENT, {
        responseType,
        createdAt,
        interactionCount
      });
    }
  }
}
